import {
  GET_URL_SUCCESS,
  GET_URL_FAILED,
  CLEAR_GET_URL,
} from '../../actionTypes';

const initialState = {
  status: '',
  message: '',
  results: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_URL_SUCCESS:
      return {
        ...state,
        status: 'success',
        message: action.message,
        results: action.results,
      };
    case GET_URL_FAILED:
      return { ...state, status: 'error', error: action.error };
    case CLEAR_GET_URL:
      return { ...initialState, status: 'clear_get_url' };
    default:
      return state;
  }
};
